import { formatMinutes } from '@hue/design-system';
import type { HolidayMode, SchedulingHoliday } from '../../lib/api.js';

export const modeOptions: Array<{ value: HolidayMode; label: string }> = [
  { value: 'CLOSED', label: 'Fechado' },
  { value: 'OPEN', label: 'Normal' },
  { value: 'REDUCED', label: 'Equipe reduzida' },
];

const weekday = new Intl.DateTimeFormat('pt-BR', { weekday: 'short', timeZone: 'UTC' });

export function holidayDateLabel(date: string): string {
  const day = weekday.format(new Date(`${date}T12:00:00Z`)).replace('.', '');
  return `${date.slice(8, 10)}/${date.slice(5, 7)} · ${day}`;
}

/// A situação em poucas palavras: "Equipe reduzida · 09:00–13:00 · 2 marcados".
export function holidayModeLabel(holiday: SchedulingHoliday): string {
  if (holiday.mode !== 'REDUCED') return modeOptions.find((o) => o.value === holiday.mode)!.label;
  const count = holiday.resourceIds.length;
  return `Equipe reduzida · ${formatMinutes(holiday.startMinute!)}–${formatMinutes(holiday.endMinute!)} · ${String(count)} ${count === 1 ? 'marcado' : 'marcados'}`;
}
